import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { ModalClose } from 'builder/components/ModalClose'

export const ModalContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 544px;
  background-color: ${Colors.White};
  border-radius: ${Spacing.S};
`

export const Header = styled.div`
  width: inherit;
  border-radius: inherit;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden;
`

export const ModalBody = styled.div`
  display: flex;
  flex-flow: column;
  padding: ${Spacing.L};
  gap: ${Spacing.M};
`

export const MainContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${Spacing['2XS']};
`

export const Title = styled.div`
  display: flex;
  gap: ${Spacing.XS};
  align-items: start;
  ${Typography.S};
  ${FontWeights.DemiBold};
`

export const Description = styled.div`
  color: ${Colors.Neutral50};
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: ${Spacing['2XS']};
`

export const CloseButton = styled(ModalClose)`
  position: absolute;
  top: ${Spacing.S};
  right: ${Spacing.S};
  z-index: 1;
`
